import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const ProtectedPrimayAgentRoute = lazy(() => import("@/components/ProtectedRoutes/ProtectedPrimayAgentRoute"));

const EditProfile = lazy(() => import("@/pages/agent/profile/edit/EditProfile"));
const Billing = lazy(() => import("@/pages/agent/profile/billing/Billing/Billing"));
const BillingInvoice = lazy(() => import("@/pages/agent/profile/billing/invoices/BillingInvoice/BillingInvoice"));

const Payouts = lazy(() => import("@/pages/agent/profile/payouts/Payouts/Payouts"));
const PayoutDetails = lazy(() => import("@/pages/agent/profile/payouts/PayoutDetails/PayoutDetails"));
const Changelogs = lazy(() => import("@/pages/agent/profile/changelogs/Changelogs"));
const Preferences = lazy(() => import("@/pages/agent/profile/preferences/Preferences"));
const Documents = lazy(() => import("@/pages/agent/profile/documents/Documents"));
const AgencyMembers = lazy(() => import("@/pages/agent/profile/agency-members/AgencyMembers"));
const AgentApplications = lazy(() => import("@/pages/agent/profile/agent-applications/AgentApplications"));

const Referrals = lazy(() => import("@/pages/agent/profile/referrals/Referrals/Referrals"));

const Error404 = lazy(() => import("@/pages/Error404"));

const profileRoutes: RouteObject[] = [
  {
    path: "edit",
    element: <EditProfile />,
  },
  {
    path: "agency-members",
    element: (
      <ProtectedPrimayAgentRoute>
        <AgencyMembers />
      </ProtectedPrimayAgentRoute>
    ),
  },
  {
    path: "agent-applications",
    element: (
      <ProtectedPrimayAgentRoute>
        <AgentApplications />
      </ProtectedPrimayAgentRoute>
    ),
  },
  {
    path: "payouts",
    children: [
      {
        index: true,
        element: <Payouts />,
      },
      {
        path: ":id",
        element: <PayoutDetails />,
      },
    ],
  },
  {
    path: "changelogs",
    element: <Changelogs />,
  },
  {
    path: "preferences",
    element: <Preferences />,
  },
  {
    path: "documents",
    element: <Documents />,
  },
  {
    path: "referrals",
    element: <Referrals />,
  },
  {
    path: "billing",
    children: [
      {
        index: true,
        element: <Billing />,
      },
      {
        path: "invoices",
        children: [
          {
            index: true,
            element: <Error404 />,
          },
          {
            path: ":id",
            element: <BillingInvoice />,
          },
        ],
      },
    ],
  },
  {
    index: true,
    element: <Error404 />,
  },
];

export default profileRoutes;
